import React, { useState } from 'react';
import { Lock, Eye, EyeOff, Loader2, ChevronRight } from 'lucide-react';
import { toast } from 'sonner';
import api from '../api';

export default function ChangePassword() {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState('');
  const [next, setNext] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) { toast.error('New password must be at least 8 characters'); return; }
    setBusy(true);
    try {
      await api.post('/auth/change-password', { current_password: cur, new_password: next });
      toast.success('Password changed successfully');
      setCur(''); setNext(''); setOpen(false);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Could not change password');
    } finally { setBusy(false); }
  };

  return (
    <div className="mt-5 overflow-hidden rounded-2xl bg-white card-soft">
      <button onClick={() => setOpen((v) => !v)} data-testid="change-password-toggle" className="flex w-full items-center gap-3 p-4 text-left">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent"><Lock className="h-5 w-5 text-[hsl(var(--coral))]" /></div>
        <div className="flex-1"><p className="font-extrabold">Change password</p><p className="text-sm text-muted-foreground">Update your account password</p></div>
        <ChevronRight className={`h-5 w-5 text-muted-foreground transition-transform ${open ? 'rotate-90' : ''}`} />
      </button>
      {open && (
        <form onSubmit={submit} className="space-y-3 border-t border-border p-4" data-testid="change-password-form">
          <div className="relative">
            <input type={show ? 'text' : 'password'} value={cur} onChange={(e) => setCur(e.target.value)} placeholder="Current password" data-testid="cp-current" className="h-11 w-full rounded-xl border border-input bg-white px-3 pr-11 text-sm outline-none focus:ring-2 focus:ring-[hsl(var(--coral))]" />
            <button type="button" onClick={() => setShow((v) => !v)} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground">{show ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}</button>
          </div>
          <input type={show ? 'text' : 'password'} value={next} onChange={(e) => setNext(e.target.value)} placeholder="New password (min 8 chars)" data-testid="cp-new" className="h-11 w-full rounded-xl border border-input bg-white px-3 text-sm outline-none focus:ring-2 focus:ring-[hsl(var(--coral))]" />
          <button type="submit" disabled={busy} data-testid="cp-submit" className="coral-btn flex w-full items-center justify-center gap-2 rounded-xl py-2.5 text-sm font-bold text-white disabled:opacity-70">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}Update password
          </button>
        </form>
      )}
    </div>
  );
}
